import {Close} from '@material-ui/icons';
import React from 'react';

export function CloseIcon() {
  return <Close fontSize="small" color="primary" />;
}
